import {ComponentType} from "react";

import {IIcon} from "@pg-design/icons-module";
import {ToggleButtonControlled} from "@pg-design/react-hook-forms-utils-module";
import {useFormContextRHF} from "@pg-mono/react-hook-forms-utils";

import {gtmOfferOpinionsFormOptionClick} from "../../../tracking/google_tag_manager/gtm_event_offer_opinions";

interface Props {
    dataTestId?: string;
    formFieldName: string;
    label: string;
    icon: ComponentType<IIcon>;
    onClick?: (value: boolean) => void;
}

export const OfferDetailOpinionsFormOption = (props: Props) => {
    const Icon = props.icon;

    const {control} = useFormContextRHF();

    const onClick = (value?: boolean) => {
        props.onClick?.(!!value);
        gtmOfferOpinionsFormOptionClick(props.label.toLowerCase());
    };

    return (
        <ToggleButtonControlled name={props.formFieldName} control={control} icon={<Icon size="2" />} onClick={onClick} dataTestId={props.dataTestId}>
            {props.label}
        </ToggleButtonControlled>
    );
};
import {ComponentType} from "react";

import {IIcon} from "@pg-design/icons-module";
import {ToggleButtonControlled} from "@pg-design/react-hook-forms-utils-module";
import {useFormContextRHF} from "@pg-mono/react-hook-forms-utils";

import {gtmOfferOpinionsFormOptionClick} from "../../../tracking/google_tag_manager/gtm_event_offer_opinions";

interface Props {
    dataTestId?: string;
    formFieldName: string;
    label: string;
    icon: ComponentType<IIcon>;
    onClick?: (value: boolean) => void;
}

export const OfferDetailOpinionsFormOption = (props: Props) => {
    const Icon = props.icon;

    const {control} = useFormContextRHF();

    const onClick = (value?: boolean) => {
        props.onClick?.(!!value);
        gtmOfferOpinionsFormOptionClick(props.label.toLowerCase());
    };

    return (
        <ToggleButtonControlled name={props.formFieldName} control={control} icon={<Icon size="2" />} onClick={onClick} dataTestId={props.dataTestId}>
            {props.label}
        </ToggleButtonControlled>
    );
};
